import HeroBg from "public/bare-metal/hero-section-background.png";

export const HERO_CONSTANTS = {
  title: "Bare-Metal Servers",
  desc: "Achieve consistent high performance with dedicated hardware designed to extend and strengthen your cloud hosting strategy.",
  button: {
    label: "Check our plans",
    link: "pricing",
  },
  button2: {
    label: "Contact us",
    link: "contact-us",
  },
  image: HeroBg,
};
